import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { get as _get } from 'lodash';

import { Claim } from '@amfam/claim/data-access';
import { Adjuster, AdjusterListService } from '@amfam/claim/shared/adjuster-list';

@Component({
  selector: 'ds-claim-detail',
  templateUrl: './claim-detail.component.html',
  styleUrls: ['./claim-detail.component.scss'],
  standalone: false
})
export class ClaimDetailComponent implements OnInit {
  @Input() claim: Claim;

  @Output() routeToClaims = new EventEmitter();

  public displayAdjuster = false;
  public adjuster: Adjuster;

  constructor(private adjusterList: AdjusterListService) {}

  ngOnInit() {
    this.adjuster = this.adjusterList.getAdjuster(this.claim);
    if (
      _get(this.claim, 'primaryFileHandler.name') &&
      _get(this.claim, 'primaryFileHandler.emails', []).length > 0
    ) {
      this.displayAdjuster = true;
    }
  }

  back() {
    this.routeToClaims.emit();
  }
}
